import { useEffect, useState } from 'react';
import { authService } from './authService';

const useIsAuthenticated = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(null);
  useEffect(() => {
    authService
      .isAuthenticated()
      .then(authenticated => setIsAuthenticated(authenticated));
  }, []);

  return isAuthenticated;
};

export default useIsAuthenticated;
